export { useAdobeTarget } from './adobe-target-client-side'
